<template>
  <div class="component">
    <b-container fluid class="pb-20 pt-30">
      <b-row class="pb-20 pl-14" v-if="canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess || canDmAccess || canCraAccess || canQualityAccess || canBioStatisticsAccess || canPharmacovigilanceAccess || canCraUBAccess || canSupportAccess">
        <b-link :to="{ name: 'list-research-site' }">Research Sites</b-link>
        <span class="text-style-1">&nbsp;/ {{ siteDetails.name }}</span>
      </b-row>
      <b-row class="pb-20 pl-14" v-if="canPiAccess || canHomeHealthAccess || canSubPiAccess || canStudyCoAccess || canDataLockAccess || canRaterAccess || canCallCenterAccess || canSupportAccess">
        <span class="selected-site-name">{{ siteDetails.name }}</span>
      </b-row>
      <!-- Buttons for edit/add/filter -->
      <!-- Table to list all the site team members -->
      <div>
        <div class="row">
          <div class="col-12">
            <div class="d-flex mb-3">
              <div class="mr-auto p-2">
                <div class="change-caret-icon">
                  <span class="clinic "></span
                  ><span class="site-id-color"
                    ><b>Site ID: {{ siteDetails.userSiteId }}</b></span
                  >
                  <div class="btn btn-primary dropdown-toggle" data-toggle="dropdown" v-if="canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess || canDmAccess || canCraAccess || canQualityAccess || canCraUBAccess || canSupportAccess" @click.stop="listToggle()">
                    <span class="caret"></span>
                  </div>
                  <ul
                    id="drop-down"
                    class="dropdown-menu"
                    :class="{
                      collapsed: !isExpanded,
                      expand: isExpanded,
                      show: isExpanded,
                      hide: !isExpanded,
                      scrollbar: sitesList.length > 9
                    }"
                  >
                    <li :id="'selected-' + site.id" :class="{ selected: siteID == site.id }" v-for="(site, index) in sitesList" :key="index" @click="fetchSiteDetails(site)">
                      <span :title="site.name" v-if="site.name.length >= 24">{{ site.userSiteId }} : {{ site.name.slice(0, 23) }}..</span>
                      <span v-if="site.name.length < 24">{{ site.userSiteId }} : {{ site.name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="p-2 text-right ml-80" v-if="canSysAdminAccess || canStudyAdminAccess || canStudyManagerAccess || canSupportAccess">
                <span>Status </span>
                <b-form-select
                  class="custom-select fs-12 width-100"
                  v-model="status"
                  @change="updateStatus"
                  :class="{
                    'text-success': status === 'Active',
                    'text-danger': status === 'Inactive',
                    'text-warning': status === 'Pending'
                  }"
                >
                  <option class="text-body" value="Pending" disabled>Pending</option>
                  <option class="text-body" value="Active">Active</option>
                  <option class="text-body" value="Inactive">Inactive</option>
                </b-form-select>
                <b-btn class="fs-12 ml-10 mr-10 edit-btn width-100" @click="editSiteDetails()">Edit</b-btn>
                <b-btn @click="openParticipantTransfer()" class="transfer-participant-btn fs-12" variant="primary" v-if="user.userRole === ('StudyAdmin' || 'SystemAdmin')">Transfer Participants</b-btn>
                <b-btn variant="primary" class="fs-12 bg-4c8ce4" v-if="!(canSysAdminAccess || canSupportAccess)" @click="viewSiteDocument()">Documents</b-btn>
                <b-btn variant="primary" class="fs-12 ml-10 bg-4c8ce4 add-icon" :class="{ 'disabled-btn': !isDataLoaded }" @click="addMember()">
                  <span class="cursor_pointer mt-5">
                    <i class="fa fa-plus fa-stack-1x icon-background-maroon border-radius50"></i>
                    <span class="add-text">Add</span>
                  </span>
                </b-btn>
              </div>
              <div class="p-2 add-pi" v-if="canPiAccess && !user.readOnly">
                <b-btn variant="primary" class="fs-14 width-120 bg-4c8ce4" :class="{ 'disabled-btn': !isDataLoaded }" @click="addMember()">
                  <span class="cursor_pointer mt-5">
                    <i class="fa fa-plus fa-stack-1x icon-background-maroon-2 border-radius50"></i>
                    <span class="add-text">Add</span>
                  </span>
                </b-btn>
              </div>
            </div>
          </div>
        </div>
        <b-row>
          <b-col cols="12">
            <!-- Table header for research sites details -->
            <b-row class="pb-10 fs-14">
              <b-col class="header-text pr-5 text-center">
                NAME
              </b-col>
              <b-col class="header-text ml-0 pl-10 pr-5">
                EMAIL
              </b-col>
              <b-col class="header-text ml-0 p-0">
                PHONE NUMBER
              </b-col>
              <b-col class="header-text ml-0 pl-0 pr-0">
                ROLE
              </b-col>
              <b-col class="header-text ml-0 p-0">
                BLINDED
              </b-col>
              <b-col class="header-text ml-0 p-0 site_status">
                SITE STATUS
              </b-col>
              <b-col v-if="canSysAdminAccess || canStudyAdminAccess || canPiAccess || canStudyManagerAccess || canSupportAccess" class="header-text ml-50 p-0 action_table">
                ACTION
              </b-col>
            </b-row>
            <!-- Site team details row -->
            <b-row class="site-card mb-10" align-v="center" v-for="(member, index) in siteDetails.siteTeam" :key="index">
              <b-col class="pr-12">
                <b-row>
                  <img class="profile-img-size" src="/static/img/profile.png" alt="user-img" />
                  <b-col class="name p-0 word-break name-color">{{ member.fullName }} </b-col>
                </b-row>
              </b-col>
              <b-col class="word-break pl-0 pr-10 ml-0">{{ member.username }}</b-col>
              <b-col class="word-break ml-0 p-0">{{ member.phoneNumber }}</b-col>
              <b-col class="word-break ml-0 p-0">
                <span v-if="member.userRole == 'Pi'">Principal Investigator</span>
                <span v-if="member.userRole == 'SubPi'">Sub-Investigator</span>
                <span v-if="member.userRole == 'StudyCoordinator'">Study Coordinator</span>
                <span v-if="member.userRole == 'HomeHealth'">Home Health</span>
                <span v-if="member.userRole == 'SiteDataLock'">Site - Data Lock</span>
                <span v-if="member.userRole == 'CallCenter'">Call Center</span>
                <span v-if="member.userRole == 'Rater'">Rater</span>
              </b-col>
              <b-col class="word-break ml-0 p-0">
                <span>{{ member.blinded ? "Blinded" : "Unblinded" }}</span>
              </b-col>
              <b-col class="word-break ml-0 p-0 site_status">
                <span class="text-warning" v-if="member.status == 'Pending'">{{ member.status }}</span>
                <span class="text-success" v-if="member.status == 'Active'">{{ member.status }}</span>
                <span class="text-danger" v-if="member.status == 'Inactive'">{{ member.status }}</span>
              </b-col>
              <b-col v-if="canSysAdminAccess || canStudyAdminAccess || canPiAccess || canStudyManagerAccess || canSupportAccess" class="word-break ml-40 p-0 inline-btn action_table">
                <span v-if="member.status == 'Pending' && (canSysAdminAccess || canStudyAdminAccess || canPiAccess || canStudyManagerAccess || canSupportAccess) && !user.readOnly">
                  <b-btn variant="primary" class="resend-btn-2" v-b-modal.invitationModal @click="currentSiteMem(index)" v-b-tooltip.hover title="Resend invite">Resend invite</b-btn>
                </span>
                <span v-if="(canSysAdminAccess || canStudyAdminAccess || canStudyAdminAccess || canPiAccess || canStudyManagerAccess || canSupportAccess) && !user.readOnly" :class="{ 'ml-95': member.status != 'Pending' }">
                  <img class="pencil" src="/static/img/ICN_Edit.png" alt="user-img" @click="openModal('editMember', index)" v-b-tooltip.hover title="Edit" />
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <!-- Site Edit Modal Component -->
      <b-modal id="editSiteDetailsModal" size="lg" ref="editSiteDetailsModal" hide-footer hide-header class="edit-modal">
        <header id="editSiteDetailsModal___BV_modal_header_" class="modal-header p-0 pl-0 pb-10">
          <h5 class="modal-title">Edit site details</h5>
          <button type="button" aria-label="Close" class="close" @click="onCloseEditModal()">
            ×
          </button>
        </header>
        <b-row class="pb-10 border-style mb-10" @focus="open = false" tabindex="-1">
          <b-col cols="8">
            <span class="header-text">Site name</span>&nbsp;&nbsp;<span class="fa fa-asterisk" aria-hidden="true"></span>
            <b-form-input
              type="text"
              class="required"
              v-model="details.name"
              placeholder="Enter name"
              name="siteName"
              v-validate="'required'"
              v-bind:class="{
                input: true,
                'is-danger': errors.has('siteName')
              }"
            >
            </b-form-input>
            <span v-if="errors.has('siteName')" class="error-style">Site name is required.</span>
          </b-col>
          <b-col cols="4">
            <span class="header-text">Site ID</span>&nbsp;&nbsp;<span class="fa fa-asterisk" aria-hidden="true"></span>
            <b-form-input
              type="text"
              class="required"
              v-model="details.userSiteId"
              placeholder="Enter ID"
              name="userSiteId"
              v-validate="'required'"
              v-bind:class="{
                input: true,
                'is-danger': errors.has('userSiteId')
              }"
            >
            </b-form-input>
            <span v-if="errors.has('userSiteId')" class="error-style">Site ID is required.</span>
          </b-col>
          <b-col cols="4" class="pt-20">
            <span class="header-text">Site type</span>
            <b-form-select :options="siteTypes" class="modal-custom-select" v-model="details.type"> </b-form-select>
          </b-col>
          <b-col cols="4" class="pt-20">
            <span class="header-text"
              >Site country
              <span
                v-b-popover.hover.html="'The <strong>site country</strong> is the country participants will be associated with when enrolled. If the site is associated to multiple countries, they can be added by clicking “Add another country.” When multiple countries are added, participants will choose which country to associate themselves with during enrollment.'"
                class="fa fa-info-circle ml-7"
              ></span
            ></span>
            <b-form-select :disabled="siteDetails.status !== 'Pending'" :options="primaryCountryOptions" v-model="primaryRegion.value" class="modal-custom-select" @change.native="selectPrimary($event)"></b-form-select>
          </b-col>
          <b-col cols="4 site-address-elements" v-if="details.type && details.type.toLowerCase() == 'virtual'">
            <b-form-group id="virtual-city-label" label="City" label-for="virtualSiteCity" :invalid-feedback="errors.first('virtualSiteCity')" :state="!errors.has('virtualSiteCity')">
              <b-form-input type="text" placeholder="City" v-validate="'alpha_spaces'" id="virtualSiteCity" name="virtualSiteCity" v-model="siteVirtualAddress.city" :state="!errors.has('virtualSiteCity')" key="virtual-city-input"> </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4 site-address-elements mt-0" v-if="details.type && details.type.toLowerCase() == 'virtual'">
            <b-form-group id="virtual-state-label" label="State / Province" label-for="virtualSiteState" :invalid-feedback="errors.first('virtualSiteState')" :state="!errors.has('virtualSiteState')">
              <b-form-input type="text" placeholder="State / Province" v-validate="'alpha_spaces'" id="virtualSiteState" name="virtualSiteState" v-model="siteVirtualAddress.state" key="virtual-state-input" :state="!errors.has('virtualSiteState')"> </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4 site-address-elements mt-0" v-if="details.type && details.type.toLowerCase() == 'virtual'">
            <b-form-group id="virtual-country-label" label-for="virtualSiteCountry" :invalid-feedback="errors.first('virtualSiteCountry')" :state="!errors.has('virtualSiteCountry')">
              <label class="col-form-label">Address country <span v-b-popover.hover.html="'The <strong>address country</strong> is the country associated to the physical address of the site.'" class="fa fa-info-circle ml-7"></span></label>
              <b-form-select name="virtualSiteCountry" id="virtualSiteCountry" class="select-arrow" v-validate="'alpha_spaces'" v-model="siteVirtualAddress.country" key="virtual-country-input" :state="!errors.has('virtualSiteCountry')">
                <option value="">Select country</option>
                <option v-for="(countryObj, indexOpt) in primaryCountryOptions" :key="indexOpt" :value="countryObj.text">{{ countryObj.text }}</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col v-if="details.type && details.type.toLowerCase() == 'virtual'" class="p-0 mt-25">
            <label for="allowPartFromAnyRegion" class="fw-normal">
              <input type="checkbox" name="allowPartFromAnyRegion" id="allowPartFromAnyRegion" class="checkbox_position" v-model="siteVirtualAddress.isAllowOtherRegionParticipant" />
              <span>Allow participants from any region</span><span v-b-popover.hover.html="'Site available to all participants from any location'" class="fa fa-info-circle ml-7"></span>
            </label>
          </b-col>
          <b-col cols="4" :class="details.type && details.type.toLowerCase() == 'virtual' ? 'pt-0' : 'pt-20'">
            <span class="header-text">Site Sub-type</span>
            <b-form-select :disabled="siteDetails.status !== 'Pending'" :options="siteSubTypes" class="modal-custom-select" v-model="details.siteSubType"> </b-form-select>
          </b-col>
          <!---approved language-->
          <b-col cols="6" :class="details.type && details.type.toLowerCase() == 'virtual' ? 'pt-0' : 'pt-20'">
            <div class="multiselect filter-form-box" id="languageSelectBox" @blur="open = false" tabindex="-1">
              <div class="selectBox">
                <span class="header-text">Approved Languages</span>
                <div
                  class="fakeclass select-arrow cursor-pointer d-block"
                  :class="{
                    open: open,
                    input: true,
                    'is-danger': errors.first('approvedLanguage')
                  }"
                  :state="!errors.has('approvedLanguage')"
                  @click="open = !open"
                >
                  <span v-if="this.languagesFilter && this.languagesFilter.length">
                    <span v-if="this.languagesFilter.length == 1 && !!this.languagesFilter[0]">
                      {{ this.languagesFilter[0].display_name }}
                    </span>
                    <span v-else>
                      Selected
                      <span class="number-badge">{{ this.languagesFilter.length }}</span>
                    </span>
                  </span>
                  <span v-else>
                    Select language(s)
                  </span>
                </div>
                <span v-show="errors.has('approvedLanguage')" class="error-style">Approved languages are required.</span>
                <div class="overSelect"></div>
              </div>
              <div id="showCheckboxesLanguage" class="select-scroll activity-builder-select-options" :class="{ selectHide: !open }">
                <div class="check_label_input d-flex custom-control custom-checkbox" v-for="language in this.approvedLanguages[this.primaryRegion.value]" :key="language.language_id">
                  <input
                    class="custom-control-input"
                    v-validate="languagesFilter.length == 0 ? 'required' : ''"
                    :id="language.language_id"
                    name="approvedLanguage"
                    @input="
                      selectedCountryLanguage({
                        selectedLanguage: language,
                        countryId: primaryRegion.value,
                        parentCall: true
                      })
                    "
                    type="checkbox"
                    :value="language"
                    v-model="languagesFilter"
                  />
                  <label class="custom-control-label checkbox-label" :for="language.language_id">{{ language.display_name }}</label>
                </div>
              </div>
            </div>
          </b-col>
          <!---End approved language-->
        </b-row>
        <b-row v-for="(option, index) in countriesSelected" :key="index" class="pb-20" @focus="open = false" tabindex="-1">
          <b-col cols="3">
            <span class="header-text">Additional Country</span>
            <b-form-select @change.native="selectCountry($event, index)" :disabled="siteDetails.status !== 'Pending'" :options="filterCountriesOptions[index]" v-model="option.value" class="modal-custom-select"></b-form-select>
          </b-col>
          <b-col cols="6">
            <approved-language-select :options="approvedLanguages[option.value]" :additionalApprovedLanguage="selectedCountryLanguages[option.value]" :countryId="option.value" :updateParentOpen="updateParentOpen" @additionalLanguage="selectedCountryLanguage($event)" />
          </b-col>
          <b-col cols="3 mt-25" v-if="siteDetails.status == 'Pending'"
            ><b-link @click="removeCountry($event, index)" class="link-color pt-10"><b>Remove</b></b-link></b-col
          >
        </b-row>
        <b-col v-if="siteDetails.status == 'Pending'" cols="12" @focus="open = false" tabindex="-1"
          ><b-link @click="addCountry($event)"><b>Add another country</b></b-link></b-col
        >

        <!-- ="details.type && details.type.toLowerCase()=='physical'"-->
        <div v-if="details.type && details.type.toLowerCase() == 'physical'" id="physical-site-container" class="site-address-elements" @focus="open = false" tabindex="-1">
          <b-row>
            <b-col cols="8">
              <b-form-group id="physical-address-label" label-for="physicalSiteAddress" :invalid-feedback="errors.first('physicalSiteAddress')" :state="!errors.has('physicalSiteAddress')">
                <label class="col-form-label">Address</label>&nbsp;&nbsp;<span class="fa fa-asterisk" aria-hidden="true"></span>
                <b-form-input type="text" placeholder="Address" v-validate="'required'" id="physicalSiteAddress" name="physicalSiteAddress" v-model="sitePhysicalAddress.address" :state="!errors.has('physicalSiteAddress')" key="physical-address-input"> </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="4" class="pl-0">
              <b-form-group id="physical-city-label" label-for="physicalSiteCity" :invalid-feedback="errors.first('physicalSiteCity')" :state="!errors.has('physicalSiteCity')">
                <label class="col-form-label">City</label>&nbsp;&nbsp;<span class="fa fa-asterisk" aria-hidden="true"></span>
                <b-form-input type="text" placeholder="City" v-validate="'required|alpha_spaces'" id="physicalSiteCity" name="physicalSiteCity" v-model="sitePhysicalAddress.city" :state="!errors.has('physicalSiteCity')" key="physical-city-input"> </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3" class="custom-width">
              <b-form-group id="physical-zip-label" label-for="physicalSiteZip" :invalid-feedback="errors.first('physicalSiteZip')" :state="!errors.has('physicalSiteZip')">
                <label class="col-form-label">Zip / Postal code</label>&nbsp;&nbsp;<span class="fa fa-asterisk" aria-hidden="true"></span>
                <b-form-input type="text" placeholder="Zip / Postal code" v-validate="'required|alpha_num'" id="physicalSiteZip" name="physicalSiteZip" v-model="sitePhysicalAddress.zipcode" :state="!errors.has('physicalSiteZip')" key="physical-zip-input"> </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="3" class="custom-width">
              <b-form-group id="physical-state-label" label-for="physicalSiteState" :invalid-feedback="errors.first('physicalSiteState')" :state="!errors.has('physicalSiteState')">
                <label class="col-form-label">State / Province</label>&nbsp;&nbsp;<span class="fa fa-asterisk" aria-hidden="true"></span>
                <b-form-input type="text" placeholder="State / Province" v-validate="'required|alpha_spaces'" id="physicalSiteState" name="physicalSiteState" v-model="sitePhysicalAddress.state" :state="!errors.has('physicalSiteState')" key="physical-state-input"> </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="3" class="custom-width-country">
              <b-form-group id="physical-country-label" label-for="physicalSiteCountry" :invalid-feedback="errors.first('physicalSiteCountry')" :state="!errors.has('physicalSiteCountry')">
                <label class="col-form-label">Address country</label>&nbsp;&nbsp;<span class="fa fa-asterisk" aria-hidden="true"></span>&nbsp;<span v-b-popover.hover.html="'The <strong>address country</strong> is the country associated to the physical address of the site.'" class="fa fa-info-circle ml-7" style="opacity: 0.5"></span>
                <b-form-select class="select-arrow" v-validate="'required|alpha_spaces'" id="physicalSiteCountry" name="physicalSiteCountry" v-model="sitePhysicalAddress.country" :state="!errors.has('physicalSiteCountry')" key="physical-country-input">
                  <option value="">Select country</option>
                  <option v-for="(countryObj, indexOpt) in primaryCountryOptions" :key="indexOpt" :value="countryObj.text">{{ countryObj.text }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="3" class="custom-width-phone">
              <b-form-group id="physical-phone-label" label="Phone" :invalid-feedback="siteAddressPhoneError ? 'Please enter a valid phone number.' : ''" :state="!siteAddressPhoneError">
                <vue-tel-input
                  class="p-0 bg"
                  :preferredCountries="['us', 'ca']"
                  :placeholder="'(      )  '"
                  @onInput="onInputSiteAddressPhone"
                  v-model="sitePhysicalAddress.phoneNumber"
                  v-bind:class="{
                    input: true,
                    'is-invalid': siteAddressPhoneError
                  }"
                ></vue-tel-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="pt-0">
              <div class="form-group mb-0">
                <label class="col-form-label d-block pt-0">Hours of operation</label>
                <b-row>
                  <b-col cols="4" class="p-0">
                    <div class="btn-group week-days" role="group">
                      <button v-for="(day, index) in weekDays" :value="day.value" :key="index" type="button" class="btn btn-outline-dark btn-sm" :class="siteOperationDays.includes(day.value) ? 'active' : ''" @click="addEditOperationDays(day.value)">
                        {{ day.text }}
                      </button>
                    </div>
                  </b-col>
                  <b-col cols="8" class="p-0">
                    <div class="form-group mb-0">
                      <label>START</label>
                      <vueTimepicker format="hh:mm A" :minute-interval="10" v-model="siteOperationStartTime" class="ml-5" name="ohStartTime"></vueTimepicker>
                      <label class="ml-20 mr-5">END</label>
                      <vueTimepicker format="hh:mm A" :minute-interval="10" v-model="siteOperationEndTime" name="ohEndTime"></vueTimepicker>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="!validateSiteOperationHours"><b-col cols="12" class="p-0 mt-0 invalid-feedback d-block">Please specify valid hours of operation</b-col></b-row>
              </div>
            </b-col>
          </b-row>
        </div>
        <div id="site-settings" @focus="open = false" tabindex="-1">
          <h6>Site Settings</h6>
          <div class="settings-conatiner">
            <b-row>
              <b-col cols="10" class="p-0"><span>Allows the ability to upload, configure, activate/deactivate site documents.</span></b-col>
              <b-col cols="2" class="p-0">
                <label class="switch-toggle-btn">
                  <input type="checkbox" v-model="canSiteTeamAddDocuments" :disabled="canSupportAccess" />
                  <div :class="canSupportAccess ? 'slider slider-disabled' : 'slider'"></div>
                  <div class="text"></div>
                </label>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="10" class="p-0">Allow sites to add participants manually.</b-col>
              <b-col cols="2" class="p-0">
                <label class="switch-toggle-btn">
                  <input type="checkbox" v-model="siteDetails.canSiteTeamAddParticipant" :disabled="canSupportAccess" />
                  <div :class="canSupportAccess ? 'slider slider-disabled' : 'slider'"></div>
                  <div class="text"></div>
                </label>
              </b-col>
            </b-row>
            <b-row v-if="canSysAdminAccess || canSupportAccess">
              <b-col cols="10" class="p-0">Allow downloading esource documents</b-col>
              <b-col cols="2" class="p-0">
                <label class="switch-toggle-btn">
                  <input type="checkbox" v-model="canSiteTeamDownloadEsourceDocs" :disabled="canSupportAccess" />
                  <div :class="canSupportAccess ? 'slider slider-disabled' : 'slider'"></div>
                  <div class="text"></div>
                </label>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row @focus="open = false" tabindex="-1">
          <b-col cols="4" class="required-disclaimer"><span class="fa fa-asterisk" aria-hidden="true"></span>&nbsp;&nbsp;indicates a required field</b-col>
          <b-col class="pull-right" cols="8">
            <b-btn variant="success" class="pull-right create-btn fs-14" @click="updateSiteDetails()">Update</b-btn>
          </b-col>
        </b-row>
        <div class="modal-style"></div>
      </b-modal>
      <!-- Site Activation/Deactivation Modal Component -->
      <b-modal id="activateSiteModal" ref="activateSiteModal" @hidden="onCloseActivateModal" hide-footer hide-header>
        <b-row class="pt-20 pb-10 border-style text-center">
          <b-col class="fs-16" cols="12" v-if="status === 'Active'">
            <b>Activating this requires you to have received all the proper approvals from, but not limited to, your IRB or EC. This will give your PI the ability to start inviting participants.</b><br /><br />
            <b>Are you ready to activate this site?</b>
          </b-col>
          <b-col class="fs-16" cols="12" v-if="status === 'Inactive'"> <b>Are you sure you want to deactivate this site? Site team members will no longer be able to access this study.</b><br /><br /> </b-col>
          <b-col offset="2" cols="8" class="pt-30">
            <b-btn variant="primary" class="btn-block fs-14 br-25 bg-4c8ce4" @click="statusUpdateSite()">
              Yes
            </b-btn>
          </b-col>
          <b-col offset="2" cols="8" class="pt-10">
            <b-btn variant="primary" class="btn-block fs-14 br-25 bg-4c8ce4" @click="onCloseActivateModal()">
              No
            </b-btn>
          </b-col>
        </b-row>
        <div class="modal-style"></div>
      </b-modal>
      <!-- Add Team Member Modal Component -->
      <addMemberModal ref="addMemDetailsModal" :siteId="siteID" :studyId="studyId" modalType="add" :activePI="activePI" :memberDetails="selectedMember" title="Add site member" @added="memberAdded" />
      <!-- Edit Team Member Modal Component -->
      <addMemberModal ref="editMemDetailsModal" :siteId="siteID" :studyId="studyId" modalType="edit" :activePI="activePI" :memberDetails="selectedMember" title="Edit site team" @updated="memberUpdated" />
      <!-- Send Invitation Modal Component -->
      <b-modal id="invitationModal" size="lg" ref="invitationModal" @hidden="onCloseInvitationModal" hide-footer hide-header>
        <b-row class="pt-20 pb-10 border-style text-center">
          <b-col class="fs-16" cols="12">
            <b>Do you want to resend invitation to {{ selectedMember.firstName }} {{ selectedMember.lastName }}?</b>
          </b-col>
          <b-col offset="3" cols="6" class="pt-30">
            <b-btn variant="primary" class="btn-block fs-14 br-25 bg-4c8ce4" @click="sendInvitation()">
              Yes
            </b-btn>
          </b-col>
          <b-col offset="3" cols="6" class="pt-20" @click="onCloseInvitationModal()">
            <b-btn class="btn-block fs-14 br-25 cancel-bg">
              No
            </b-btn>
          </b-col>
        </b-row>
        <div class="modal-style"></div>
      </b-modal>
      <!-- add site team memeber modal -->
      <add-site-team-members :isPopupEnabled="siteTeamMemberModalPopUp" :options="{ role: 'all', title: 'Add Site Team' }" :siteTeamList="siteDetails.siteTeam" :allActiveSiteTeamMember="allActiveMembers" :isRoleDropdownDisabled="activePI" @getSiteTeamSelected="addTeamMembers" @searchForMember="searchForMember"> </add-site-team-members>
    </b-container>
  </div>
</template>

<script>
import sortBy from "lodash/sortBy";
import flattenDeep from "lodash/flattenDeep";
import cloneDeep from "lodash/cloneDeep";
import filter from "lodash/filter";
import _ from "lodash";
import { SYSTEM_ADMIN, STUDY_ADMIN, PI, STUDY_MANAGER, CRA, DM, QUALITY, HOME_HEALTH, SUB_PI, STUDY_COORDINATOR, SITEDATALOCK, BSTAT, PHV, RATER, CC, CraUB, SUPPORT } from "@/constants/authRoles";
import addMemberModal from "@/components/research-team/add-team-members";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import $ from "jquery";
import toastr from "toastr";
import vueTimepicker from "vue2-timepicker";
import addSiteTeamMembers from "@/components/research-team/add-site-team-members";
import ApprovedLanguageSelect from "./approved-language-select";

const dict = {
  custom: {
    physicalSiteAddress: {
      required: "Site address is required"
    },
    physicalSiteCity: {
      required: "Site city is required",
      alpha_spaces: "Site city may only contain alphabetic characters as well as spaces."
    },
    physicalSiteZip: {
      required: "Site zip/postal code is required",
      alpha_num: "Site zip/postal code may only contain alpha-numeric characters."
    },
    physicalSiteState: {
      required: "Site state/province is required",
      alpha_spaces: "Site state/province may only contain alphabetic characters as well as spaces."
    },
    physicalSiteCountry: {
      required: "Site address country is required",
      alpha_spaces: "Site address country may only contain alphabetic characters as well as spaces."
    },
    virtualSiteCity: {
      alpha_spaces: "Site city may only contain alphabetic characters as well as spaces."
    },
    virtualSiteState: {
      alpha_spaces: "Site state/province may only contain alphabetic characters as well as spaces."
    },
    virtualSiteCountry: {
      alpha_spaces: "Site address country may only contain alphabetic characters as well as spaces."
    }
  }
};

export default {
  name: "research-site",
  data() {
    return {
      studyId: this.$route.params.studyId,
      siteID: this.$route.params.siteId,
      statusFilters: [
        { text: "Pending", value: "Pending", disabled: true },
        { text: "Active", value: "Active" },
        { text: "Inactive", value: "Inactive" }
      ],
      siteTypes: [
        { text: "Select", value: null, disabled: true },
        { text: "Virtual", value: "Virtual" },
        { text: "Physical", value: "Physical" }
      ],
      siteSubTypes: [
        { text: "Select", value: null, disabled: true },
        { text: "Live", value: "LIVE" },
        { text: "Test", value: "TEST" }
      ],
      open: false,
      selectedCountryLanguages: {},
      languagesFilter: [],
      selectedLanguageOption: [],
      approvedLanguages: [],
      siteDetails: {},
      selectedMember: {},
      details: {},
      status: "",
      activePI: false,
      countriesSelected: [],
      actualCountriesObj: [],
      //countriesOptions: [],
      primaryRegion: [],
      filterCountriesOptions: [],
      actualOptions: [],
      primaryCountryOptions: [],
      isEditMode: false,
      oldValuePrimary: null,
      primaryCountryType: null,
      selectedLanguageName: "English (US)",
      sitePhysicalAddress: {
        address: "",
        city: "",
        zipcode: "",
        state: "",
        country: "",
        phoneNumber: ""
      },
      siteVirtualAddress: {
        city: "",
        state: "",
        country: "",
        isAllowOtherRegionParticipant: false
      },
      siteAddressPhoneError: false,
      weekDays: [
        { value: "1", text: "S" },
        { value: "2", text: "M" },
        { value: "3", text: "T" },
        { value: "4", text: "W" },
        { value: "5", text: "T" },
        { value: "6", text: "F" },
        { value: "7", text: "S" }
      ],
      siteOperationDays: [],
      siteOperationStartTime: {
        hh: "",
        mm: "",
        A: ""
      },
      siteOperationEndTime: {
        hh: "",
        mm: "",
        A: ""
      },
      sitesList: [],
      isExpanded: false,
      siteTeamMemberModalPopUp: false,
      allActiveMembers: [],
      isDataLoaded: false,
      userRole: {
        Pi: "Principal Investigator",
        SubPi: "Sub-Investigator",
        StudyCoordinator: "Study Coordinator",
        HomeHealth: "Home Health",
        SiteDataLock: "Site - Data Lock",
        CallCenter: "Call Center",
        Rater: "Rater"
      },
      canSiteTeamAddDocuments: true,
      canSiteTeamDownloadEsourceDocs: false
    };
  },
  components: {
    ApprovedLanguageSelect,
    addMemberModal,
    vueTimepicker,
    addSiteTeamMembers
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    cloneCountries: function() {
      return JSON.parse(JSON.stringify(this.primaryRegion));
    },
    validateSiteOperationHours() {
      const sod = this.siteOperationDays.length;
      let isValid = false;
      if (sod == 0 && this.siteOperationStartTime.hh === "" && this.siteOperationStartTime.mm === "" && this.siteOperationStartTime.A === "" && this.siteOperationEndTime.hh === "" && this.siteOperationEndTime.mm === "" && this.siteOperationEndTime.A === "") {
        isValid = true;
      } else if (sod > 0 && this.siteOperationStartTime.hh !== "" && this.siteOperationStartTime.mm !== "" && this.siteOperationStartTime.A !== "" && this.siteOperationEndTime.hh !== "" && this.siteOperationEndTime.mm !== "" && this.siteOperationEndTime.A !== "") {
        isValid = true;
      } else {
        isValid = false;
      }
      return isValid;
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    }
  },
  mounted() {
    this.$validator.localize("en", dict);
    setTimeout(() => {
      this.getStudyDetails();
    }, 2000);
  },
  watch: {
    "primaryRegion.value": function(newValue, oldvalue) {
      if (oldvalue !== undefined) {
        this.selectedCountryLanguages = {};
      }
      this.languagesFilter = [];
    }
  },
  methods: {
    updateParentOpen() {
      this.open = false;
    },
    openParticipantTransfer() {
      const studyId = this.studyId;
      const siteId = this.siteDetails.id;
      this.$router.push({
        name: "study-participants-list",
        params: { studyId, siteId: siteId, participantTransfer: true }
      });
    },
    addTeamMembers(data) {
      this.$api.addSiteTeamMembers(this.studyId, this.siteID, data).then(
        () => {
          toastr.success("Team member added successfully.");
          this.getTeamMembers();
        },
        error => {
          if (error.body) {
            toastr.error(error.body.message);
          }
        }
      );
    },
    searchForMember(data) {
      this.$api.searchSiteTeamMember(this.studyId, this.siteID, data).then(
        response => {
          this.allActiveMembers = this.processTeamMemberList(response.body);
        },
        () => {
          toastr.error("Error while fetching the records");
        }
      );
    },
    sortCountries(countries) {
      countries.map((c, index) => {
        if (c.text == "US") {
          countries.splice(0, 0, c);
          countries.splice(index + 1, 1);
        }
      });
      return countries;
    },
    getCountryType(countryId) {
      return _.result(
        _.find(this.actualCountriesObj, function(c) {
          return c.countryId === countryId;
        }),
        "countryType"
      );
    },
    getCountryGroupId(countryId) {
      return _.result(
        _.find(this.actualCountriesObj, function(c) {
          return c.countryId === countryId;
        }),
        "countryGroupId"
      );
    },
    selectPrimary(event) {
      if (event && event.target && event.target.value) {
        if (_.includes(_.map(this.countriesSelected, "value"), event.target.value)) {
          toastr.error("This country has already been selected");
          this.$nextTick(function() {
            // DOM updated
            this.primaryRegion.value = this.oldValuePrimary;
          });
          return;
        }
      }
      this.filterCountriesOptions = [];
      this.countriesSelected = [];
      this.oldValuePrimary = event.target.value;
    },
    selectCountry(element, index) {
      if (element.target.value == this.primaryRegion.value) {
        toastr.error("This country has already been selected");
        this.$nextTick(function() {
          // DOM updated
          this.countriesSelected[index].value = this.countriesSelected[index].previousValue;
        });
        return;
      }
      const primaryCountryGroupId = this.getCountryGroupId(this.primaryRegion.value);
      this.primaryCountryType = this.getCountryType(this.primaryRegion.value);
      //CHECK THE data sovereignty/privacy/storage restriction
      if (this.getCountryGroupId(element.target.value) != primaryCountryGroupId) {
        //CHECK THE DATA RESTRICTION (Only type 2 and 3 has data restriction)
        const additionalCountryType = this.getCountryType(element.target.value);

        if ((this.primaryCountryType == 2 || this.primaryCountryType == 3) && additionalCountryType != this.primaryCountryType) {
          toastr.error("This country follows different data storage and/or privacy rules than the one that has already been selected. Please create a separate site for this country.");
          this.$nextTick(function() {
            // DOM updated
            this.countriesSelected[index].value = this.countriesSelected[index].previousValue;
          });
          return;
        } else {
          toastr.error("This country has data storage and/or privacy restrictions. Please create a separate site for this country.");
          this.$nextTick(function() {
            // DOM updated
            this.countriesSelected[index].value = this.countriesSelected[index].previousValue;
          });
          return;
        }
      }
      const self = this;
      this.countriesSelected[index].value = element.target.value;
      this.countriesSelected[index].previousValue = element.target.value;
      this.countriesSelected.filter((country, idx) => {
        this.filterCountriesOptions[idx] = this.primaryCountryOptions.filter(function(e) {
          return e.value != self.primaryRegion.value;
        });
      });
      for (let i = 0; i < this.countriesSelected.length; i++) {
        for (let k = 0; k < this.filterCountriesOptions.length; k++) {
          if (i != k) {
            for (let j = 0; j < this.filterCountriesOptions[k].length; j++) {
              if (this.filterCountriesOptions[k][j].value == this.countriesSelected[i].value) {
                this.filterCountriesOptions[k].splice(j, 1);
              }
            }
          }
        }
      }
    },
    setOptions(value, options, index) {
      for (let i = 0; i < options.length; i++) {
        const newRow = _.cloneDeep(options[i]);
        for (let k = 0; k < newRow.length; k++) {
          if (index != i && value == newRow[k].value) {
            newRow.splice(k, 1);
          }
        }
        this.$set(options, i, newRow);
      }
    },
    fetchGroupID(gID) {
      const countries = this.actualCountriesObj.filter(c => {
        //Filter the countries that belongs to the primary country group
        return c.countryGroupId === gID; // Country id condition removed because we are displaying the primary country itself in the additional drop downs
      });
      const filterOptions = this.processCountries(countries);
      this.actualOptions = JSON.parse(JSON.stringify(filterOptions));
      this.filterCountriesOptions.length = filterOptions.length;
      for (let i = 0; i < this.filterCountriesOptions.length; i++) {
        this.filterCountriesOptions[i] = filterOptions;
      }
      if (this.filterCountriesOptions.length == 0 || this.filterCountriesOptions.length < this.countriesSelected.length) {
        this.countriesSelected.length = 0;
      }

      if (!this.isEditMode) {
        this.countriesSelected.length = 0;
        return;
      }
      this.isEditMode = false;
      for (let i = 0; i < this.countriesSelected.length; i++) {
        this.setOptions(this.countriesSelected[i].value, this.filterCountriesOptions, i);
      }
    },
    removeCountry(evt, index) {
      const self = this;
      evt.preventDefault();
      const removedCountryID = this.countriesSelected[index].previousValue;
      if (removedCountryID) {
        delete this.selectedCountryLanguages[removedCountryID];
      }
      this.countriesSelected.splice(index, 1);
      this.countriesSelected.filter((country, idx) => {
        this.filterCountriesOptions[idx] = this.primaryCountryOptions.filter(function(e) {
          return e.value != self.primaryRegion.value;
        });
      });
      // FILTER OUT COUNTRIES THOSE ARE SELECTED
      for (let i = 0; i < this.countriesSelected.length; i++) {
        for (let k = 0; k < this.filterCountriesOptions.length; k++) {
          if (i != k) {
            for (let j = 0; j < this.filterCountriesOptions[k].length; j++) {
              if (this.filterCountriesOptions[k][j].value == this.countriesSelected[i].value) {
                this.filterCountriesOptions[k].splice(j, 1);
              }
            }
          }
        }
      }
    },
    addCountry(evt) {
      evt.preventDefault();
      if (this.languagesFilter.length == 0) {
        toastr.error("Approved languages are required.");
        return;
      }
      const ifNUllEntryExists = this.countriesSelected.filter(c => {
        return c.value == null;
      });
      if (ifNUllEntryExists.length != 0) {
        toastr.error("Please select additional country.");
        return;
      }
      if (this.validateCountriesLanguage()) {
        toastr.error("Approved languages are required.");
        return;
      }
      const self = this;
      this.countriesSelected.push({
        text: null,
        value: null,
        previousValue: null
      });
      this.countriesSelected.filter((country, idx) => {
        this.filterCountriesOptions[idx] = this.primaryCountryOptions.filter(function(e) {
          return e.value != self.primaryRegion.value;
        });
      });
      for (let i = 0; i < this.countriesSelected.length; i++) {
        for (let k = 0; k < this.filterCountriesOptions.length; k++) {
          if (i != k) {
            for (let j = 0; j < this.filterCountriesOptions[k].length; j++) {
              if (this.filterCountriesOptions[k][j].value == this.countriesSelected[i].value) {
                this.filterCountriesOptions[k].splice(j, 1);
              }
            }
          }
        }
      }
    },
    processCountries(countries, isPrimary) {
      if (isPrimary) {
        this.isEditMode = true;
        if (this.siteDetails.primaryCountry && this.siteDetails.primaryCountry != "") {
          this.primaryRegion = { value: _.clone(this.siteDetails.primaryCountry) };
          this.oldValuePrimary = _.clone(this.siteDetails.primaryCountry);
        } else {
          this.primaryRegion = { value: countries[0].countryId };
          this.oldValuePrimary = countries[0].countryId;
        }
      }
      const listOfCountries = [];
      countries.map((c, index) => {
        if (isPrimary && this.primaryRegion && this.primaryRegion.value && this.primaryRegion.value == c.countryId) {
          //Do nothing
        } else {
          listOfCountries.push({
            text: c.countryName,
            value: c.countryId,
            previousValue: c.countryId
          });
        }
      });
      return listOfCountries;
    },
    getStudyDetails() {
      const getStudyData = JSON.parse(window.localStorage.getItem("studyDetailsData"));
      this.actualCountriesObj = getStudyData.countryList;
      this.sitesList = sortBy(getStudyData.sitesInfo, "userSiteId");
      //PRIMARY COUNTRY DROPDOWN OPTIONS
      this.primaryCountryOptions = this.processCountries(this.actualCountriesObj, false);
      this.primaryCountryOptions = this.sortCountries(this.primaryCountryOptions);
      //Approved Language
      this.approvedLanguages = getStudyData.approvedLanguages;
      this.getSiteDetails();
    },
    async getSiteDetails() {
      const self = this;
      let getSiteIdDetails = JSON.parse(window.localStorage.getItem("getSiteIdDetails"));
      if (getSiteIdDetails === null) {
        const response = await this.$api.getSiteDetailsFact(this.studyId, this.siteID);
        getSiteIdDetails = response.body;
      }
      this.siteDetails = getSiteIdDetails;
      if (getSiteIdDetails) {
        this.canSiteTeamAddDocuments = getSiteIdDetails.canSiteTeamAddDocuments;
        this.canSiteTeamDownloadEsourceDocs = getSiteIdDetails.canSiteTeamDownloadEsourceDocs;
      }
      const list = this.siteDetails.countryList;
      this.selectedCountryLanguages = getSiteIdDetails.approvedSiteLanguages;
      //Already selected countries that is used to prepare drop-down
      this.countriesSelected = this.processCountries(list, true);
      const primaryCountryID = this.primaryRegion.value;
      //Selected Approved Languages
      const languagesCountryFilter = !!getSiteIdDetails.approvedSiteLanguages[primaryCountryID] && getSiteIdDetails.approvedSiteLanguages[primaryCountryID];
      const linkedCountryLanguage =
        !!getSiteIdDetails.linkedCountryLanguages[primaryCountryID] &&
        getSiteIdDetails.linkedCountryLanguages[primaryCountryID].map(item => {
          return item.name;
        });
      if (!!languagesCountryFilter && !!linkedCountryLanguage) {
        this.languagesFilter = languagesCountryFilter.filter(data => linkedCountryLanguage.includes(data.name));
      }
      // PREPARE ADDITIONAL COUNTRY DROPDOWN OPTIONS (SELECTED COUNTRIES WILL NOT BE SHOWN IN ADDITIONAL OPTIONS)
      // FILTER OUT ONLY PRIMARY REGION
      this.countriesSelected.filter((country, idx) => {
        this.filterCountriesOptions[idx] = this.primaryCountryOptions.filter(function(e) {
          return e.value != self.primaryRegion.value;
        });
      });
      // FILTER OUT COUNTRIES THOSE ARE SELECTED
      for (let i = 0; i < this.countriesSelected.length; i++) {
        for (let k = 0; k < this.filterCountriesOptions.length; k++) {
          if (i != k) {
            for (let j = 0; j < this.filterCountriesOptions[k].length; j++) {
              if (this.filterCountriesOptions[k][j].value == this.countriesSelected[i].value) {
                this.filterCountriesOptions[k].splice(j, 1);
              }
            }
          }
        }
      }
      this.status = this.siteDetails.status;
      this.getTeamMembers();
    },

    getTeamMembers() {
      this.$api.getSiteTeamFact(this.studyId, this.siteID).then(
        response => {
          this.siteDetails.siteTeam = [];
          this.siteDetails.siteTeamList = [];
          let team = response.body;
          team.forEach(member => {
            // push all the members with status as Active
            member.fullName = member.firstName + " " + member.lastName;
            if (member.status === "Active") {
              this.siteDetails.siteTeamList.push({
                name: member.name,
                email: member.username,
                role: member.userRole,
                blinded: member.blinded
              });
            }
          });
          team.forEach((member, index) => {
            if (member.userRole === "Pi" && member.status === "Active") {
              this.siteDetails.siteTeam.push(member);
              team.splice(index, 1);
            }
          });
          team = _.orderBy(team, [s => s != undefined && s["firstName"].toLowerCase()], "asc"); // sortBy(team, 'firstName');
          this.siteDetails.siteTeam.push(team);
          this.siteDetails.siteTeam = flattenDeep(this.siteDetails.siteTeam);
          this.$forceUpdate();
          const pis = filter(this.siteDetails.siteTeam, o => o.userRole === "Pi" && (o.status === "Active" || o.status === "Pending"));
          if (pis.length > 0) {
            this.activePI = true;
          } else {
            this.activePI = false;
          }
          this.getAllActiveMembers();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site team details.");
        }
      );
    },
    viewSiteDocument() {
      this.$router.push({
        name: "add-research-site-documents",
        params: { siteId: this.siteID }
      });
    },
    openModal(name, index) {
      if (name === "addMember") {
        this.selectedMember = {};
        this.$refs.addMemDetailsModal.show();
      }
      if (name === "editMember") {
        this.selectedMember = this.siteDetails.siteTeam[index];
        this.$refs.editMemDetailsModal.show();
      }
    },
    async editSiteDetails() {
      this.details = {};
      await this.getSiteDetails();

      this.details = cloneDeep(this.siteDetails);

      this.setAddressFields(); // Set database values to fields
      this.$validator.reset(); //Reset Form Errors
      this.siteAddressPhoneError = false; //Remove phone error

      this.$refs.editSiteDetailsModal.show();
    },
    onCloseEditModal() {
      this.$swal({
        title: "Are you sure you want to cancel?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "No",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$refs.editSiteDetailsModal.hide();
        }
      });
    },
    onCloseActivateModal() {
      this.status = this.siteDetails.status;
      this.$refs.activateSiteModal.hide();
    },
    processCountriesForSites() {
      const countryList = [];
      this.actualCountriesObj.forEach((c, index) => {
        this.countriesSelected.forEach(item => {
          if (c.countryId == item.value) {
            countryList.push(this.actualCountriesObj[index]);
          }
        });
        if (c.countryId == this.primaryRegion.value) {
          countryList.push(c);
        }
      });
      return countryList;
    },
    validateCountriesLanguage() {
      let nullValues = false;
      this.countriesSelected.forEach(item => {
        if (!this.selectedCountryLanguages[item.value] || this.selectedCountryLanguages[item.value].length == 0) {
          nullValues = true;
          return false;
        }
      });
      return nullValues;
    },
    updateSiteDetails() {
      // check for null values
      const nullyC = this.countriesSelected.filter(c => {
        return c.value == null;
      });
      if (nullyC.length > 0) {
        toastr.error("Please select country.");
        return;
      }
      if (this.validateCountriesLanguage()) {
        toastr.error("Approved languages are required.");
        return;
      }

      if (this.details.type.toLowerCase() == "physical" && (this.siteAddressPhoneError || !this.validateSiteOperationHours)) {
        return;
      }

      let data = {
        name: this.details.name,
        userSiteId: this.details.userSiteId,
        type: this.details.type,
        siteSubType: this.details.siteSubType,
        countryList: this.processCountriesForSites(),
        canSiteTeamDownloadEsourceDocs: this.canSiteTeamDownloadEsourceDocs,
        canSiteTeamAddDocuments: this.canSiteTeamAddDocuments,
        canSiteTeamAddParticipant: this.siteDetails.canSiteTeamAddParticipant,
        approvedLanguages: this.selectedCountryLanguages,
        primaryCountry: this.primaryRegion.value
      };

      if (this.details.type.toLowerCase() == "physical") {
        data = {
          ...data,
          ...this.sitePhysicalAddress,
          operationHours: this.siteOperationDays.join(",") + " - " + this.getTimeString(this.siteOperationStartTime) + " - " + this.getTimeString(this.siteOperationEndTime)
        };
      } else {
        data = { ...data, ...this.siteVirtualAddress };
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.$api.updateSiteDetailsFact(this.studyId, this.siteID, data).then(
            response => {
              this.getSiteDetails();
              const detailsResponse = response.body;
              this.siteDetails.name = detailsResponse.name;
              this.siteDetails.userSiteId = detailsResponse.userSiteId;
              this.siteDetails.type = detailsResponse.type;
              this.siteDetails.siteSubType = detailsResponse.siteSubType;
              this.$toastr.success("Site details updated successfully");
              this.$refs.editSiteDetailsModal.hide();
              this.resetAddressDataProperties();
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
            }
          );
        }
      });
    },
    selectedCountryLanguage(event) {
      if (event.parentCall) {
        this.open = false;
      }
      this.selectedCountryLanguages[event.countryId] = event.selectedLanguage;
      if (this.primaryRegion.value == event.countryId) {
        this.onChangeLanguageFilter(event.selectedLanguage, event.countryId);
      }
      delete this.selectedCountryLanguages[event.previousCountryId];
      if (event.parentCall) {
        this.open = true;
      }
    },
    onChangeLanguageFilter(language, countryId) {
      const optionIndex = this.languagesFilter.findIndex(lang => lang.language_id === language.language_id);
      if (optionIndex === -1) {
        this.languagesFilter.push(language);
      } else {
        this.languagesFilter.splice(optionIndex, 1);
      }
      this.selectedCountryLanguages[countryId] = this.languagesFilter;
    },
    updateStatus() {
      this.$refs.activateSiteModal.show();
    },
    statusUpdateSite() {
      const data = {
        status: this.status
      };
      this.$api.updateSiteStatusFact(this.studyId, this.siteDetails.id, data).then(
        () => {
          this.siteDetails.status = this.status;
          if (this.status === "Active") {
            this.$toastr.success("Site activated successfully");
          }
          if (this.status === "Inactive") {
            this.$toastr.success("Site deactivated successfully");
          }
          this.$refs.activateSiteModal.hide();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
        }
      );
    },
    onCloseInvitationModal() {
      this.$refs.invitationModal.hide();
    },
    currentSiteMem(index) {
      this.selectedMember = this.siteDetails.siteTeam[index];
    },
    sendInvitation() {
      this.$api.sendInviteTeamMemberFact(this.studyId, this.siteID, this.selectedMember.id, null).then(
        () => {
          this.$toastr.success("Team member invitation sent successfully");
          this.$refs.invitationModal.hide();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
        }
      );
    },
    memberAdded() {
      this.selectedMember = {};
      this.$toastr.success("Team member added successfully");
      this.getTeamMembers();
    },
    memberUpdated() {
      this.selectedMember = {};
      this.getTeamMembers();
    },
    additionCountryOptions(primaryCountry) {
      const self = this;
      return this.primaryCountryOptions.filter(c => {
        return c.value !== primaryCountry && !_.includes(_.map(self.countriesSelected, "value"), c.value);
      });
    },
    onInputSiteAddressPhone({ number, isValid }) {
      if (!isValid && number.length > 0) {
        this.siteAddressPhoneError = true;
      } else {
        this.siteAddressPhoneError = false;
      }
    },
    addEditOperationDays(day) {
      const findDayIndex = _.findIndex(this.siteOperationDays, function(d) {
        return d == day;
      });

      if (findDayIndex == -1) {
        this.siteOperationDays.push(day);
      } else {
        this.$delete(this.siteOperationDays, findDayIndex);
      }
    },
    getTimeString(timeObj) {
      return `${timeObj.hh}:${timeObj.mm} ${timeObj.A}`;
    },
    setAddressFields() {
      if (this.details.type.toLowerCase() == "physical") {
        const physicalAddressKeys = _.keys(this.sitePhysicalAddress);
        physicalAddressKeys.forEach(field => {
          this.sitePhysicalAddress[field] = this.details[field] ? this.details[field] : "";
        });

        if (this.details.operationHours && this.details.operationHours.length > 0) {
          const splitOh = this.details.operationHours.split(" - ");
          this.siteOperationDays = splitOh[0].length > 0 ? splitOh[0].split(",") : [];
          this.siteOperationStartTime = this.getTimeObject(splitOh[1]);
          this.siteOperationEndTime = this.getTimeObject(splitOh[2]);
        }
      } else {
        const virtualAddressKeys = _.keys(this.siteVirtualAddress);
        virtualAddressKeys.forEach(field => {
          this.siteVirtualAddress[field] = this.details[field] ? this.details[field] : "";
        });
      }
    },
    getTimeObject(timeString) {
      const str1 = timeString.split(" ");
      const timeStr = str1[0].split(":");
      return { hh: timeStr[0], mm: timeStr[1], A: str1[1] };
    },
    resetAddressDataProperties() {
      this.sitePhysicalAddress = {
        address: "",
        city: "",
        zipcode: "",
        state: "",
        country: "",
        phoneNumber: ""
      };
      this.siteVirtualAddress = {
        city: "",
        state: "",
        country: "",
        isAllowOtherRegionParticipant: false
      };
      this.siteAddressPhoneError = false;

      this.siteOperationDays = [];
      this.siteOperationStartTime = {
        hh: "",
        mm: "",
        A: ""
      };
      this.siteOperationEndTime = {
        hh: "",
        mm: "",
        A: ""
      };
    },
    listToggle() {
      this.isExpanded = !this.isExpanded;
      this.$nextTick(() => {
        this.scrollElement();
      });
    },
    scrollElement() {
      const container = $("#drop-down");

      const scrollTo = $("#selected-" + this.siteID);
      container.animate({
        scrollTop: (scrollTo.offset() && scrollTo.offset().top) - container.offset().top + container.scrollTop()
      });
    },
    getAllActiveMembers() {
      this.isDataLoaded = false;
      this.$api.getSiteTeamMembers(this.studyId, this.siteID).then(response => {
        // remove PI if PI is already invited
        this.allActiveMembers = this.processTeamMemberList(response.body);
        this.isDataLoaded = true;
      });
    },
    processTeamMemberList(members) {
      const records = [];
      if (members.length > 0) {
        members.map(m => {
          if (!(this.activePI && m.userRole == "Pi")) {
            records.push(m);
          } else if (!this.activePI) {
            records.push(m);
          }
        });
      }
      return records;
    },
    addMember() {
      this.siteTeamMemberModalPopUp = !this.siteTeamMemberModalPopUp;
    },
    fetchSiteDetails(siteDetail) {
      this.$router.push({
        name: "research-site-details",
        params: { siteId: siteDetail.id }
      });
      this.isExpanded = !this.isExpanded;
      this.siteID = siteDetail.id;
      this.getSiteDetails();
    }
  }
};
</script>
<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss" src="@/assets/dropdown-css.scss"></style>
<style scoped lang="scss">
@import "~@/assets/variables.scss";
.edit-modal {
  .modal-header {
    padding-left: 15px !important;
  }
}
.transfer-participant-btn {
  background-color: #ffffff;
  border: none;
  color: #4c8ce4;
  padding: 8px 0 5.4px 1px;
  margin-right: 8px;
  // ---
  width: 130px;
  height: 32px;
  border: 1px solid #ced4da;
  font-weight: 500;
}
#languageSelectBox {
  position: relative;
}
.custom-select {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none;
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down.png);
  padding: 0.5em;
}
.select-arrow {
  background: url("/static/img/arrow-down.png") no-repeat bottom 6px right 18px transparent !important;
}
.component {
  background-color: $color_content_background;
  .fa-asterisk {
    color: #ff3e49;
    font-size: 9px;
  }
}
.link-color {
  color: #f16559;
  font-weight: 300;
}
.custom-select {
  height: auto !important;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
}

.modal-custom-select {
  height: 36px !important;
}

.icon-color {
  color: #d3dfe4;
}

.delete-icon {
  color: #666669;
}

.br-1 {
  border-right: 1px solid #d3dfe4;
}

.header-text {
  color: #666669 !important;
  opacity: 0.5;
  font-size: 10px;
  font-family: Roboto-Regular;
  font-weight: bold;
}

.profile-img-size {
  width: 25px;
  height: 27px;
  margin-right: 10px;
}

.width-180 {
  width: 180px !important;
}

.width-100 {
  width: 100px !important;
}

.text-body {
  color: #666669;
}

.bg-4c8ce4 {
  background-color: #4c8ce4 !important;
  border: #4c8ce4 !important;
}

.edit-btn {
  background-color: #ffffff !important;
  border-radius: 3px;
  border: solid 1px #d3dfe4 !important;
  color: #4c8ce4 !important;
}

.width-120 {
  width: 80px !important;
}

.site-card {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 20px 0px;
  width: 100%;
  font-family: Roboto-Regular;
  color: #666669;
}

.create-btn {
  border-radius: 100px;
  border: none;
  width: 120px;
  height: 35px;
}

.modal-delete {
  border-radius: 3px;
  background-color: #d3dfe4;
  width: 35px;
  height: 35px;
  text-align: center;
}

.error-bg {
  background-color: #f16559;
  border: #f16559;
}

.cancel-bg {
  background-color: #d3dfe4;
  border: #d3dfe4;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

/deep/ .modal-header {
  border-bottom: none !important;
  padding-left: 30px !important;
}

/deep/ .modal-title {
  font-weight: bold !important;
}
</style>
<style lang="scss">
@media (min-width: 992px) {
  #editSiteDetailsModal {
    .col-3 {
      &.custom-width {
        max-width: 20% !important;
        padding-right: 0;
      }
      &.custom-width-country {
        max-width: 21% !important;
        padding-right: 0;
      }
      &.custom-width-phone {
        flex: 0 0 33%;
        max-width: 33%;
        padding-right: 0;
        .vue-tel-input {
          border-color: #d3dfe4;
          .dropdown {
            padding: 8px;
          }
        }
      }
    }
  }
}
#editSiteDetailsModal {
  .site-address-elements {
    margin-top: 20px;
    margin-bottom: 20px;
    .form-group {
      .form-control {
        &.is-valid {
          border-color: #d3dfe4;
          background-image: none;
          &:focus {
            border-color: #d3dfe4;
            box-shadow: inherit;
          }
        }
      }
      label,
      label.col-form-label,
      legend.col-form-label {
        color: #666669;
        opacity: 0.7;
        padding-bottom: inherit;
        padding-top: 0;
        margin-bottom: 0;
      }

      .vue-tel-input,
      select.custom-select {
        &.is-invalid {
          border-color: #dc3545;
        }
      }

      .time-picker {
        width: 6em;
        .clear-btn {
          right: -8px;
        }
        input {
          &.display-time {
            border: 1px solid #d3dfe4;
            height: 33px !important;
            width: 6em;
          }
        }
      }

      select.custom-select {
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        &.is-valid {
          background-image: url("/static/img/arrow-down.png") no-repeat;
          background: url("/static/img/arrow-down.png") no-repeat;
        }
      }
    }
    .week-days {
      button {
        padding: 4px 10px;
      }
      .btn-outline-dark {
        border-color: #e4e8eb;
      }

      .btn-outline-dark:hover,
      .btn-outline-dark:not(:disabled):not(.disabled):active,
      .show > .btn-outline-dark.dropdown-toggle {
        color: inherit;
        background: #e4e8eb;
        border-color: #e4e8eb;
      }
      .btn-outline-dark.active {
        border-color: #ffffff;
      }
      .btn-outline-dark:not(:disabled):not(.disabled):active:focus,
      .btn-outline-dark:not(:disabled):not(.disabled).active:focus,
      .show > .btn-outline-dark.dropdown-toggle:focus,
      .btn-outline-dark:focus {
        box-shadow: none;
      }
      .btn-outline-dark:not(:disabled):not(.disabled).active {
        background-color: #1e8fe1;
        border-color: #1e8fe1;
        color: #fff;
      }
    }
  }
  #allowPartFromAnyRegion {
    vertical-align: middle;
    margin-right: 6px;
  }
  #allowPartFromAnyRegion ~ .fa-info-circle {
    opacity: 0.7;
  }
  .required-disclaimer {
    font-family: Lato-Semibold;
    font-size: 10px;
    padding-top: 12px;
    color: #4a4a4a;
    .fa-asterisk {
      font-size: 6px;
      vertical-align: 1px;
    }
  }
  .header-text {
    font-size: 14px;
    opacity: 0.7;
    font-weight: normal;
  }
}
.resend-btn {
  display: inline-block;
  border: 1.5px solid #1e8fe1;
  border-radius: 5px;
  padding: 6px;
  font-size: 11px;
  color: #1e8fe1;
}
.grey-in-color {
  color: #9b9b9b;
}
.clinic {
  background-image: url("/static/img/clinic_3.png");
  display: inline-block;
  width: 32px;
  height: 25px;
  background-repeat: no-repeat;
  background-size: contain;
}
.change-caret-icon .btn.btn-primary {
  background-color: #fff;
  border: none;
  color: #666769;
  padding: 0px;
  position: relative;
  display: inline-block;
  top: -15px;
  left: 18px;
  width: 0px !important;
}
.change-caret-icon .dropdown-toggle[data-v-627fd5e4]::after {
  color: #666769;
}
html body .change-caret-icon #drop-down {
  top: 31px !important;
  left: 48px !important;
  li {
    cursor: pointer;
  }
  &.expand {
    width: 219px;
    max-height: 313px !important;
    -moz-transition: all 400ms ease-out;
    -webkit-transition: all 400ms ease-out;
    -o-transition: all 400ms ease-out;
    -ms-transition: all 400ms ease-out;
    transition: all 400ms ease-out;
  }
  &.collapsed {
    max-height: 0;
    transition: all 400ms ease-in;
    -moz-transition: all 400ms ease-in;
    -webkit-transition: all 400ms ease-in;
    -o-transition: all 400ms ease-in;
    -ms-transition: all 400ms ease-in;
    overflow: hidden;
  }
}
.selected {
  font-weight: bold;
  background: #efefef;
}
.pencil-icon {
  background-image: url(/static/img/edit.svg);
  width: 12px;
  height: 12px;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
}
.icon-background-maroon {
  height: 20px;
  left: 6px;
  top: 5px;
  color: #4c8ce4 !important;
  width: 22px;
  background: #fff !important;
  border-radius: 3px;
  padding-top: 2px;
}
.icon-background-maroon-2 {
  height: 19px;
  left: 23px;
  top: 6px;
  color: #4c8ce4 !important;
  width: 22px;
  background: #fff !important;
  border-radius: 3px;
  position: inherit;
  margin-right: 9px;
}
.add-icon {
  width: 70px;
  position: relative;
}
.add-text {
  float: right;
}
.disabled-btn {
  opacity: 0.5;
  pointer-events: none;
}
.btn-wrapper {
  border-radius: 3px;
  border: 1.5px solid #c5d1d6;
  width: 40%;
  padding: 2px 2px;
  position: relative;
  cursor: pointer;
  .fa-plus {
    border: 1px solid #b0bac9;
    padding: 2px 3px;
    border-radius: 3px;
    background: #b0bac9;
    color: #fff;
  }
  .btn-text {
    padding-left: 10px;
    color: #4c8ce4;
  }
}
.action-position {
  top: -18px;
  padding-left: 1254px !important;
}
.resend-btn-2 {
  width: 79px;
  height: 30px;
  margin: 0 12px 0 6px;
  padding: 5px 0;
  background-color: #fff;
  font-family: Roboto-Regular;
  font-size: 11px;
  color: #1e8fe1;
  display: inline-block;
  float: left;
  border: 1.5px solid #1e8fe1;
  border-radius: 5px;
}
.resend-btn-2:hover {
  width: 79px;
  height: 30px;
  margin: 0 12px 0 6px;
  padding: 5px 0;
  background-color: #f5f8fa;
  font-family: Roboto-Regular;
  font-size: 11px;
  color: #1e8fe1;
  display: inline-block;
  float: left;
  border: 1.5px solid #1e8fe1;
  border-radius: 5px;
}
.add-pi {
  float: right;
  margin-bottom: 10px;
}
.selected-site-name {
  margin: -9px 78px -4px 3px;
  font-family: Roboto-Regular;
  font-size: 14px;
  letter-spacing: normal;
  color: #9b9b9b;
}
.ml-95 {
  margin-left: 10% !important;
}
.pencil {
  cursor: pointer;
}
.name-color {
  color: #4c8ce4;
}
.site-id-color {
  font-size: 18px !important;
  color: #2d3752;
  font-family: "Roboto-Regular";
}
@media (min-width: 768px) and (max-width: 1023px) {
  .resend-btn-2 {
    width: 65px;
    height: 30px;
    margin: 0 0px 0 0px;
    padding: 4px 2px;
    font-size: 0.6rem;
    border-radius: 5px;
  }
  .site-card {
    font-size: 0.7rem;
  }
  .site_status {
    width: 70px;
    max-width: 70px;
  }
  .action_table {
    width: 50px;
    max-width: 67px;
    margin-left: 0 !important;
    text-align: center;
  }
}

#site-settings {
  margin: 1rem;

  h6 {
    font-family: Roboto-Medium;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    color: #b1b1b4;
    margin-bottom: 3px;
  }
  .settings-conatiner {
    border-radius: 3px;
    border: solid 1px #e4e8eb;
    padding: 21px 20px;
    color: #666669;
    font-family: Roboto-Regular;
    font-size: 14px;

    .row {
      padding-bottom: 21px;
      padding-top: 21px;
      border-bottom: 1px solid #e4e8eb;
      &:first-of-type {
        padding-top: 0;
      }
      &:last-of-type {
        padding-bottom: 0;
        border-bottom: 0;
      }
    }
  }
  /*toggle btn css*/
  .switch-toggle-btn {
    position: relative;
    display: inline-block;
    width: 100px;
    height: 24px;
    font-size: 14px;
    margin: 0;
    cursor: pointer;
  }
  .switch-toggle-btn input {
    opacity: 0;
  }

  .switch-toggle-btn .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e0e0e0;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 15px;
  }

  .switch-toggle-btn .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    top: 3px;
    background-color: #fff;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  .switch-toggle-btn input:checked + .slider {
    background-color: #2ecd6c;
  }
  .switch-toggle-btn input:checked + .slider-disabled {
    background-color: #aaeac3 !important;
  }

  .switch-toggle-btn input:focus + .slider {
    box-shadow: 0 0 1px #2ecd6c;
  }

  .switch-toggle-btn input:checked + .slider:before {
    -webkit-transform: translateX(75px);
    -ms-transform: translateX(75px);
    transform: translateX(75px);
  }

  .switch-toggle-btn .text {
    color: white;
  }

  .switch-toggle-btn .text:after {
    position: absolute;
    top: 2px;
    right: 15px;
    content: "Disabled";
    -webkit-transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    transition: opacity 0.5s ease-in-out;
  }
  .switch-toggle-btn .text:before {
    position: absolute;
    top: 2px;
    left: 15px;
    content: "Enabled";
    -webkit-transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    transition: opacity 0.5s ease-in-out;
  }

  .switch-toggle-btn input + .slider + .text:after {
    opacity: 1;
  }
  .switch-toggle-btn input + .slider + .text:before {
    opacity: 0;
  }

  .switch-toggle-btn input:checked + .slider + .text:after {
    opacity: 0;
  }

  .switch-toggle-btn input:checked + .slider + .text:before {
    opacity: 1;
  }
}
.language-search-bar {
  width: 100%;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.check_label_input input {
  float: left;
  line-height: 30px;
  margin-top: 8px;
  -webkit-margin-before: 8px;
}
#showCheckboxesLanguage {
  background: #fff;
  position: absolute;
  width: 100% !important;
  height: auto;
  max-height: 250px;
  border-radius: 3px;
  padding: 10px;
  overflow: scroll;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}
.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}
.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
.select-scroll {
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}
.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}
.checkbox-label {
  padding-top: 2.8px;
}
.fakeclass {
  height: 36px;
  padding: 8px 10px 7px 8px;
  border-radius: 4px;
  border: solid 1px #d3dfe4;
}
.number-badge {
  width: 18px;
  height: 20px;
  flex-grow: 0;
  margin: 0 0 0 5px;
  padding: 0 5px;
  border-radius: 4px;
  background-color: #e0e0e0;
  color: #4c8ce4;
}
.selectHide {
  display: none;
}
</style>
